import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Detect if running in Electron
const isElectron = !!(window as any).electron;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
